//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  components: {
  },
  props: ['boardId', 'type', 'isreWrite', 'isbackWrite', 'hasCallBack', 'stopDown'],
  name: 'FrhomoloHandWrite',
  data() {
    return {
      mousedown: false,
      history: [],
      step: -1,
      ctx: null,
      cas: null,
      blob: null,
      base64Img: '',
      imageType: 'image/png',
      showHideOnBlur: false
    }
  },
  methods: {
    frhomoloWriteDownPC(e) {
      this.mousedown = true;
      if (this.step < this.history.length - 1) {
        this.history.length = this.step + 1;
      }
      this.ctx.beginPath();
      this.start = [e.offsetX, e.offsetY];
      this.ctx.moveTo(e.offsetX, e.offsetY);
    },
    frhomoloWritemovePC(e) {
      if (!this.mousedown) {
        return
      }
      this.ctx.strokeStyle = '#000';
      this.ctx.lineTo(e.offsetX, e.offsetY);
      this.ctx.stroke();
    },
    frhomoloWriteUpPC(e) {
      if (this.mousedown) {
        this.mousedown = false;
        this.step++;
      }
      if (this.step > -1) {
        // 显示撤回按钮
      }
      this.history.push(this.cas.toDataURL());
    },
    frhomoloWriteDown(e) {
      e.preventDefault();
      this.mousedown = true;
      if (this.step < this.history.length - 1) {
        this.history.length = this.step + 1;
      }
      this.ctx.beginPath();
      this.start = [e.touches[0].pageX - this.$refs.canvasWrite.offsetLeft, e.touches[0].pageY - this.$refs.canvasWrite.offsetTop];
      this.ctx.moveTo(e.touches[0].pageX - this.$refs.canvasWrite.offsetLeft, e.touches[0].pageY - this.$refs.canvasWrite.offsetTop);
    },
    frhomoloWriteUp(e) {
      e.preventDefault();
      if (this.mousedown) {
        this.mousedown = false;
        this.step++;
      }
      if (this.step > -1) {
        // 显示撤回按钮
      }
      this.history.push(this.cas.toDataURL());
    },
    frhomoloWritemove(e) {
      e.preventDefault();
      if (!this.mousedown) {
        return
      }
      this.ctx.strokeStyle = '#000';
      this.ctx.lineTo(e.touches[0].pageX - this.$refs.canvasWrite.offsetLeft, e.touches[0].pageY - this.$refs.canvasWrite.offsetTop);
      this.ctx.stroke();
    },
    clearWrite(e) {
      e.preventDefault();
      e.stopPropagation();
      this.history = [];
      this.step = -1;
      this.ctx.clearRect(0, 0, this.cas.width, this.cas.height);
    },
    exportWrite(e) {
      e.preventDefault();
      let type = this.imageType || 'image/png';
      this.base64Img = this.cas.toDataURL(type, 1.0);
      this.toBlob(this.cas);
    },
    toBlob(mycanvas) {
      console.log(mycanvas)
      if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
          value: function (callback, type, quality) {
            let canvas = this;
            setTimeout(function () {
              let binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
              let len = binStr.length;
              let arr = new Uint8Array(len);
              for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
              }
              callback(new Blob([arr], { type: type }));
            });
          }
        });
      }
      let type = this.imageType || 'image/png';
      mycanvas.toBlob((blob) => {
        if (!this.stopDown) {
          this.showHideOnBlur = true;
        }
        this.blob = blob;
        if (this.hasCallBack) {
          this.$emit('callback', this.blob, this.base64Img);
        }
      }, type);
    },
    backWrite(e) {
      e.preventDefault();
      e.stopPropagation();
      let that = this;
      this.step--;
      this.ctx.clearRect(0, 0, this.cas.width, this.cas.height);
      if (this.step < 0) {
        return;
      }
      let images = new Image();
      images.src = this.history[this.step];
      images.onload = function () {
        that.ctx.drawImage(images, 0, 0);
      };
    },
    reWrite(e) {
      e.preventDefault();
      e.stopPropagation();
      let that = this;
      this.step++;
      let images = new Image();
      images.src = this.history[this.step];
      images.onload = function () {
        that.ctx.drawImage(images, 0, 0);
      };
    }
  },
  watch: {
    type() {
      if (this.type) {
        if (this.type === 'png' || this.type === 'jpg' || this.type === 'jpeg' || this.type === 'webp') {
          this.imageType = 'image/' + this.type;
        } else if (this.type.startsWith('image/')){
          this.imageType = this.type;
        }
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.cas = document.querySelector('#hand-write' + this.boardId);
    this.cas.width = document.querySelector('#hand-write' + this.boardId).clientWidth;
    this.cas.height = document.querySelector('#hand-write' + this.boardId).clientHeight;
    this.ctx = this.cas.getContext('2d');
    this.ctx.lineWidth = 1;
  }
};
